module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange-ee948ef74aa54e18b4da2cdf2820583a.png";